import React, { useState, useEffect } from 'react';
import { Icons } from '../icons';

const ThemeToggle = () => {
      const [theme, setTheme] = useState('light');

      useEffect(() => {
            // Periksa apakah sessionStorage memiliki nilai
            let sessionTheme = sessionStorage.getItem('theme');
            if (!sessionTheme) {
                  // Jika sessionStorage kosong, gunakan nilai dari localStorage
                  const storedTheme = localStorage.getItem('theme') || 'light';
                  sessionStorage.setItem('theme', storedTheme);
                  sessionTheme = storedTheme;
            }

            // Terapkan tema berdasarkan sessionStorage
            if (sessionTheme === 'dark') {
                  document.documentElement.classList.add('dark');
                  setTheme('dark');
            } else {
                  document.documentElement.classList.remove('dark');
                  setTheme('light');
            }
      }, []);

      const toggleTheme = () => {
            if (theme === 'light') {
                  document.documentElement.classList.add('dark');
                  localStorage.setItem('theme', 'dark'); // Simpan ke localStorage
                  sessionStorage.setItem('theme', 'dark'); // Simpan ke sessionStorage
                  setTheme('dark');
            } else {
                  document.documentElement.classList.remove('dark');
                  localStorage.setItem('theme', 'light'); // Simpan ke localStorage
                  sessionStorage.setItem('theme', 'light'); // Simpan ke sessionStorage
                  setTheme('light');
            }
      };

      return (
            <button
                  className={`${theme === 'light' ? 'bg-[#292F36]' : 'bg-theme-dark_card2/50'} rounded-full w-[50px] h-[28px] p-1 flex items-center transition-transform duration-300`}
                  onClick={toggleTheme}
            >
                  <div
                        className={`w-5 h-5 rounded-full transform transition-transform duration-300 flex items-center justify-center ${theme === 'light' ? 'translate-x-[22.5px] bg-[#1A1E23]' : 'translate-x-0 bg-[#DFE3E8]'
                              }`}
                  >
                        <Icons.mode className="w-4 h-4 object-cover text-[#788790]" />
                  </div>
            </button>
      );
};

export default ThemeToggle;
